namespace GeniuzPOS.ReportMasterData {
    export interface Report_1309Form {
        ShopId: Serenity.LookupEditor;
        ShopName: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        GrossSales: Serenity.DecimalEditor;
        AllItemDiscount: Serenity.DecimalEditor;
        NetSales: Serenity.DecimalEditor;
        NetSalesExVat: Serenity.DecimalEditor;
        VatOfNetSales: Serenity.DecimalEditor;
        AllItemCharge: Serenity.DecimalEditor;
        VatOfCharge: Serenity.DecimalEditor;
    }

    export class Report_1309Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1309';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Report_1309Form.init)  {
                Report_1309Form.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(Report_1309Form, [
                    'ShopId', w0,
                    'ShopName', w1,
                    'DocDate', w2,
                    'GrossSales', w3,
                    'AllItemDiscount', w3,
                    'NetSales', w3,
                    'NetSalesExVat', w3,
                    'VatOfNetSales', w3,
                    'AllItemCharge', w3,
                    'VatOfCharge', w3
                ]);
            }
        }
    }
}
